import { createFileRoute } from "@tanstack/react-router";
import { SEOServicePage } from "./services_.seo";

export const Route = createFileRoute("/services_/seo-services")({
  head: () => ({
    meta: [
      {
        title: "SEO Services (Search Engine Optimisation) — KMWAdvertising",
      },
      {
        name: "description",
        content: "Data-Driven Technical & Content SEO Services.",
      },
    ],
  }),
  component: SEOServicePage,
});
